/**
 * CUSTOMIZATION: Site-wide display date format (Presidio).
 * Calendar dates always render as MM-dd-yyyy (US).
 */
export const DISPLAY_DATE_FORMAT = 'MM-dd-yyyy';
export const DISPLAY_DATETIME_FORMAT = 'MM-dd-yyyy, HH:mm';
export const DISPLAY_DATETIME_SECONDS_FORMAT = 'MM-dd-yyyy, HH:mm:ss';

/** date-fns / NgbDateParserFormatter pattern (same tokens as Angular for this case). */
export const DISPLAY_DATE_PARSE_FORMAT = 'MM-dd-yyyy';

/**
 * Map Angular named date formats (and day-first / slash patterns) to MM-dd-yyyy.
 * Time-only formats (`shortTime`, `mediumTime`, …) are left unchanged.
 */
export function resolveDisplayDateFormat(format = 'mediumDate'): string {
  switch (format) {
    case 'shortDate':
    case 'mediumDate':
    case 'longDate':
    case 'fullDate':
      return DISPLAY_DATE_FORMAT;
    case 'short':
      return DISPLAY_DATETIME_FORMAT;
    case 'medium':
    case 'long':
    case 'full':
      return DISPLAY_DATETIME_SECONDS_FORMAT;
    default:
      // Rewrite day-first numeric patterns to MM-dd-yyyy (keep any time suffix).
      if (/^(d{1,2})\/(M{1,2})\//.test(format)) {
        return format.replace(/^(d{1,2})\/(M{1,2})\//, 'MM-dd-');
      }
      if (/^(d{1,2})-(M{1,2})-/.test(format)) {
        return format.replace(/^(d{1,2})-(M{1,2})-/, 'MM-dd-');
      }
      // Normalize slash US patterns to hyphenated US display.
      if (/^(M{1,2})\/(d{1,2})\//.test(format)) {
        return format.replace(/^(M{1,2})\/(d{1,2})\//, 'MM-dd-');
      }
      return format;
  }
}

/**
 * Format an NgbDateStruct-like value for date-range displays (MM-dd-yyyy).
 * Used by Orders / Invoices / Devices range pickers.
 */
export function formatDisplayDateParts(year: number, month: number, day: number): string {
  return `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}-${year}`;
}
